import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer style={{
      backgroundColor: '#2c3e50',
      color: 'white',
      marginTop: '80px',
      padding: '60px 0 20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px'
      }}>
        {/* Üst Kısım - 4 Sütun */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          
          {/* 1. Sütun - Şirket Bilgisi */}
          <div>
            <h3 style={{ 
              marginBottom: '20px', 
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#fff'
            }}>
              MEBS İpek Aksesuar
            </h3>
            <p style={{ 
              lineHeight: '1.8', 
              color: '#bdc3c7',
              marginBottom: '10px' 
            }}>
              Premium kalite ipek ürünleri ile hayatınıza şıklık katıyoruz.
            </p>
            <p style={{ color: '#bdc3c7', fontSize: '14px' }}>
              {/* BURAYA ŞİRKET SLOGANI YAZIN */}
              "Zarafet ve Kalitenin Buluştuğu Nokta"
            </p>
          </div>

          {/* 2. Sütun - İletişim Bilgileri */}
          <div>
            <h4 style={{ 
              marginBottom: '20px', 
              fontSize: '18px',
              color: '#fff'
            }}>
              📞 İletişim
            </h4>
            <div style={{ color: '#bdc3c7' }}>
              <p style={{ marginBottom: '10px' }}>
                <strong>Email:</strong><br />
                {/* BURAYA EMAIL ADRESİ YAZIN */}
                iletisim@mebssilk.com
              </p>
              <p>
                <strong>Adres:</strong><br />
                {/* BURAYA ÇALIŞMA SAATLERİ YAZIN */}
                Şerif Ali Cad. Alyakut Sok. No:9 D:5<br />
                Küçükbakkalköy/Ataşehir/İstanbul 34750
              </p>
            </div>
          </div>

          {/* 3. Sütun - Hızlı Linkler */}
          <div>
            <h4 style={{ 
              marginBottom: '20px', 
              fontSize: '18px',
              color: '#fff'
            }}>
              🔗 Hızlı Erişim
            </h4>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0,
              color: '#bdc3c7'
            }}>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/hakkimizda" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.target.style.color = '#3498db'}
                onMouseOut={(e) => e.target.style.color = '#bdc3c7'}>
                  Hakkımızda
                </Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/urunler" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.target.style.color = '#3498db'}
                onMouseOut={(e) => e.target.style.color = '#bdc3c7'}>
                  Ürünlerimiz
                </Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/mesafeli-satis-sozlesmesi" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.target.style.color = '#3498db'}
                onMouseOut={(e) => e.target.style.color = '#bdc3c7'}>
                  Teslimat ve İade Şartları
                </Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/kvkk" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.target.style.color = '#3498db'}
                onMouseOut={(e) => e.target.style.color = '#bdc3c7'}>
                  Gizlilik Politikası
                </Link>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Link to="/iletisim" style={{
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.target.style.color = '#3498db'}
                onMouseOut={(e) => e.target.style.color = '#bdc3c7'}>
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* 4. Sütun - Sosyal Medya ve Adres */}
          <div>
            <h4 style={{ 
              marginBottom: '20px', 
              fontSize: '18px',
              color: '#fff'
            }}>
              📍 Sosyal Medya
            </h4>
            
            {/* Adres */}
            <div style={{ marginBottom: '20px', color: '#bdc3c7' }}>
              {/* BURAYA FİZİKİ ADRES YAZIN */}
        
            </div>

            {/* Sosyal Medya Linkleri */}
            <div style={{ marginBottom: '20px' }}>
              <p style={{ marginBottom: '15px', color: '#fff' }}>
                <strong>Bizi Takip Edin:</strong>
              </p>
              <div style={{ display: 'flex', gap: '15px' }}>
                {/* INSTAGRAM */}
                <a 
                  href="https://instagram.com/mebsipekaksesuar" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#E4405F',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    color: 'white',
                    transition: 'transform 0.3s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  title="Instagram"
                >
                  <span style={{ fontSize: '20px' }}>📷</span>
                </a>
              </div>
            </div>

            {/* Ödeme Yöntemleri */}
            <div>
              <p style={{ marginBottom: '10px', color: '#fff' }}>
                <strong>Güvenli Ödeme:</strong>
              </p>
              <img
                src="/iyzico-footer.png"
                alt="iyzico güvenli ödeme - Visa, MasterCard"
                style={{ maxWidth: '200px', display: 'block', marginBottom: '10px' }}
              />
            </div>
          </div>
        </div>

        {/* Alt Çizgi */}
        <hr style={{ 
          border: 'none', 
          borderTop: '1px solid #34495e', 
          margin: '40px 0 20px' 
        }} />

        {/* En Alt Kısım - Copyright ve Ekstra Bilgiler */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div>
            <p style={{ color: '#95a5a6', fontSize: '14px' }}>
              © 2026 MEBS İpek Aksesuar. Tüm hakları saklıdır.
            </p>
            <p style={{ color: '#95a5a6', fontSize: '12px', marginTop: '5px' }}>
              {/* BURAYA VERGİ BİLGİLERİ YAZIN */}
              
            </p>
          </div>
          
          <div style={{ textAlign: 'right' }}>
            <p style={{ color: '#95a5a6', fontSize: '12px' }}>
              {/* BURAYA TASARIMCI/GELİŞTİRİCİ BİLGİSİ */}
              Designed by Eymen
            </p>
            <p style={{ color: '#95a5a6', fontSize: '12px', marginTop: '5px' }}>
              {/* SSL ve GÜVENLİK BİLGİSİ */}
              🔒 SSL Güvenli Alışveriş
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;